import {StaticImage} from 'gatsby-plugin-image';
import React from 'react';
import Module from './Module';
import {SVG} from './SVG';

const SocialModule: React.FC = () => (
  <Module className="SocialModule" width="Unconstrained">
    <h4>People are Talking!</h4>
    <div className="Badges">
      <a href="https://www.g2.com/products/miter/reviews?utm_source=review-widget" target="mitersocial">
        <StaticImage
          className="BadgeG2Stars"
          src="../../images/badge-g2-stars.png"
          alt="Badge showing five stars on G2"
        />
      </a>
      <a href="https://www.g2.com/products/miter/reviews?utm_source=high-performer-widget" target="mitersocial">
        <SVG name="BadgeG2Summer2022" />
      </a>
      <a href="https://www.capterra.com/p/246473/Miter/" target="mitersocial">
        <SVG name="BadgeCapterra" />
      </a>
      <a
        href="https://www.producthunt.com/posts/miter?utm_source=badge-top-post-badge&utm_medium=badge&utm_souce=badge-miter"
        target="mitersocial"
      >
        <img
          className="BadgeProductHunt"
          src="https://api.producthunt.com/widgets/embed-image/v1/top-post-badge.svg?post_id=350461&theme=dark&period=daily"
          alt="Miter - Run&#0032;better&#0032;meetings | Product Hunt"
          width="250"
          height="54"
        />
      </a>
    </div>
  </Module>
);

export default SocialModule;
